import React from "react";
import PropTypes from "prop-types";
import GenericContactTable from "../../../../../../../components/ContactsTable/GenericContactsTable";
import { contactRoles } from "../../../config/mgmtContactConfig";
import useManagementContacts from "../../../hooks/useManagementContacts";
import { useSelector, useDispatch } from "react-redux";
import {
  setSelectedContact,
  clearSelectedContact,
} from "../../../../../../../redux/mgmtCo/selectedContactSlice";

const ManagementContactTable = ({ isEditMode, onAddNew, onRowClick }) => {
  const selectedManagement = useSelector((state) => state.selectedManagement);
  const managementId = selectedManagement?.managementId;
  const selectedContact = useSelector(
    (state) => state.selectedManagementContact
  );
  const dispatch = useDispatch();

  // Define onSelectContact to dispatch the action.
  const onSelectContact = (contact) => {
    console.log("Selected contact:", contact);
    console.log(selectedContact);
    if (selectedContact && selectedContact.contactID === contact.contactID) {
      dispatch(clearSelectedContact());
    } else {
      dispatch(setSelectedContact(contact));
    }
  };

  return (
    <GenericContactTable
      isEditMode={isEditMode}
      onAddNew={onAddNew}
      onRowClick={onRowClick}
      onSelectContact={onSelectContact} // pass the function
      rolesConfig={contactRoles}
      useContactsHook={useManagementContacts}
      entityId={managementId}
      selectedContact={selectedContact}
    />
  );
};

ManagementContactTable.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  onAddNew: PropTypes.func,
  onRowClick: PropTypes.func,
};

export default ManagementContactTable;
